/* https://brandplatform.smartphoto.com/general/popups/loading-dialog/ */
import {disableUserEvents, expressQuerySelector, expressToggleClass} from "../../common/html";
import {IDisposable} from "../../utils/disposable";

export function showLoadingDialog<T>(promise: Promise<T>, timeToShowLoadingDialog = 200, extraTimeOutAfterResolving?: number, timeoutToDisableLoadingDialog?: number): Promise<T> {
	const htmlEl = expressQuerySelector(document, "html", true);
	const bodyEl = expressQuerySelector(document, "body", true);
	const dialogEl = expressQuerySelector<HTMLElement>(bodyEl, ".technical-loading-dialog", true);
	let disposable: IDisposable;
	htmlEl.style.top = -(document.documentElement.scrollTop) + 'px';
	bodyEl.style.top = -(document.documentElement.scrollTop) + 'px';

	const toggleClasses = (show: boolean) => {
		expressToggleClass(dialogEl, "u-hide", !show);
	};

	const show = setTimeout(() => toggleClasses(true), timeToShowLoadingDialog);
	const blockingEventDisposables = disableUserEvents();
	let manualTimeoutToDisableLoadingDialog;
	const disableLoadingDialog = () => {
		clearTimeout(show);
		if (manualTimeoutToDisableLoadingDialog)
			clearInterval(manualTimeoutToDisableLoadingDialog);
		blockingEventDisposables.dispose();
		htmlEl.style.top = '';
		bodyEl.style.top = '';
		toggleClasses(false);
		if (disposable) disposable.dispose();
	};

	if (timeoutToDisableLoadingDialog)
		manualTimeoutToDisableLoadingDialog = setInterval(() => disableLoadingDialog(), timeoutToDisableLoadingDialog);

	return promise.finally(() => {
		if (extraTimeOutAfterResolving) {
			setTimeout(() => disableLoadingDialog(), extraTimeOutAfterResolving);
		}
		else
			disableLoadingDialog();
	});
}
